var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "next-steps-container" },
    [
      _vm._l(_vm.config, function (nextStep, nextStepIndex) {
        return _c(
          "div",
          { key: nextStepIndex },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-primary",
                on: {
                  click: function ($event) {
                    return _vm.runNextStep(nextStep, nextStepIndex)
                  },
                },
              },
              [_vm._v(_vm._s(nextStep["label"]))]
            ),
            _c("research-loading-spinner", {
              attrs: { isLoading: _vm.loading, colorStyle: "color" },
            }),
          ],
          1
        )
      }),
      _vm.workFlowMessage && typeof _vm.workFlowMessage == "string"
        ? _c("div", { staticClass: "workflow-message" }, [
            _c(
              "div",
              {
                staticClass: "alert alert-info",
                staticStyle: { "margin-top": "10px", display: "inline-block" },
              },
              [_vm._v(_vm._s(_vm.workFlowMessage))]
            ),
          ])
        : _vm._e(),
      _vm.workFlowMessage && typeof _vm.workFlowMessage == "object"
        ? _c(
            "div",
            { staticClass: "workflow-message" },
            [
              _c("research-data-table", {
                attrs: {
                  pageID: 1,
                  dataset: _vm.workFlowMessage.data,
                  tableFormat: _vm.tableFormat,
                  initPerPageNumber: 5,
                  tableLegend: "",
                  searchParameters: null,
                  pkgData: null,
                  pkgDataSelected: null,
                  phenotypeMap: null,
                  sectionId: 1,
                  multiSectionPage: true,
                  starItems: null,
                  utils: _vm.utils,
                  region: null,
                  regionZoom: null,
                  regionViewArea: null,
                  colors: null,
                  plotMargin: null,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }